import GroupsPage from "../pages/GroupsPage/GroupsPage";
import UsersPage from "../pages/UsersPage/UsersPage";
import EventsPageThird from "../pages/EventsPageThird/EventsPageThird";
import ReducedEventGate from "../pages/EventsPageThird/ReducedEventGate";
import { VIEWER_ROLES } from "../utils/ViewerContext";
import EventsPageSecond from "../pages/EventsPageSecond/EventsPageSecond";
import EventsPageFirst from "../pages/EventsPageFirst/EventsPageFirst";
import LanguagesPage from "../pages/LanguagesPage/LanguagesPage";
import DashboardPage from "../pages/DashboardPage/DashboardPage";
import EmailTemplates from "../pages/EmailTemplates/EmailTemplates";

const getRoutes = (t, role) => {
  const RoutesFirst = [
    {
      to: "/",
      icon: "calendar",
      iconDark: "calendar_dark",
      title: t("EVENTS_TITLE"),
      element: <EventsPageFirst t={t} />,
    },
  ];

  const RoutesSecond = [
    {
      to: "/",
      icon: "calendar",
      iconDark: "calendar_dark",
      title: t("EVENTS_TITLE"),
      element: <EventsPageSecond t={t} />,
    },
  ];

  const RoutesThird = [
    {
      to: "/",
      icon: "dashboard",
      iconDark: "dashboard_dark",
      title: t("DASHBOARD"),
      element: <DashboardPage />,
    },
    {
      to: "/groups",
      icon: "grid",
      iconDark: "grid_dark",
      title: t("GROUPS"),
      element: <GroupsPage t={t} />,
    },
    {
      to: "/users",
      icon: "user",
      iconDark: "user_dark",
      title: t("USERS_TITLE"),
      element: <UsersPage t={t} />,
    },
    {
      to: "/events",
      icon: "calendar",
      iconDark: "calendar_dark",
      title: t("EVENTS_TITLE"),
      element: <EventsPageThird t={t} />,
    },
    {
      to: "/translations",
      icon: "language",
      iconDark: "language_dark",
      title: t("LANGUAGES"),
      element: <LanguagesPage t={t} />,
    },
    {
      to: "/email-templates",
      icon: "email_template",
      iconDark: "email_template_dark",
      title: t("TEMPLATES"),
      element: <EmailTemplates t={t} />,
    },
  ];

  // xsscan/xsinfo accounts logging into the main tier get a single reduced
  // screen (QR scan / accreditation search) instead of the full admin nav —
  // see EventThirdPage, which renders that reduced screen per event, and
  // ReducedEventGate, which skips the event picker straight to it.
  const RoutesThirdReduced = [
    {
      to: "/",
      icon: "calendar",
      iconDark: "calendar_dark",
      title: t("EVENTS_TITLE"),
      element: <ReducedEventGate t={t} />,
    },
  ];

  const mode = process.env.REACT_APP_MODE;

  switch (mode) {
    case "first":
      return RoutesFirst;
    case "second":
      return RoutesSecond;
    case "third":
      return [VIEWER_ROLES.XSSCAN, VIEWER_ROLES.XSINFO].includes(role)
        ? RoutesThirdReduced
        : RoutesThird;
    default:
      return [];
  }
};

export default getRoutes;
